<template>
  <b-modal id="modal-external-id" ref="addressSearchModal" :title="$t('sandoz.address_search')"
                    :ok-only="true" size="xl" :ok-title="$t('core.cancel')">
    <form @submit.prevent="search()">
      <b-input-group>
        <input v-model="query" type="text" class="form-control">
        <b-input-group-append>
          <b-dropdown variant="primary" type="submit" right split :text="$t('core.search')" @click.prevent="search()">
            <b-dropdown-item @click.prevent="search(true)">{{$t('core.search_in_my_contract')}}</b-dropdown-item>
          </b-dropdown>
        </b-input-group-append>
      </b-input-group>
    </form>

    <b-overlay :show="displayOverlay" rounded="sm">
      <div class="table-responsive">
        <table class="table">
          <thead>
            <th v-if="contractType === 'apoone'">{{$t('sandoz.customer_no')}}</th>
            <th v-else>{{$t('sandoz.customer_external_id')}}</th>
            <th>{{$t('sandoz.name')}}</th>
            <th v-if="contractType !== 'apoone'">{{$t('sandoz.customer_type')}}</th>
            <th>{{$t('sandoz.organisation')}}</th>
            <th>{{$t('sandoz.street')}}</th>
            <th>{{$t('sandoz.zip')}}</th>
            <th>{{$t('sandoz.city')}}</th>
            <th></th>
          </thead>
          <tbody>
            <tr v-for="(result, resultIndex) in searchResult" :key="resultIndex">

              <td v-if="contractType === 'apoone'">{{ result.customer_no}}</td>
              <td v-else>{{(result.org_external_id && !multipleContractsPerPractice) ? result.org_external_id : result.external_id}}</td>

              <td v-if="contractType === 'apoone'">{{ result.person_name}}</td>
              <td v-else>{{result.job_title ? result.job_title + ' ' + result.full_name : result.full_name}}</td>

              <td v-if="contractType !== 'apoone'">{{result.sub_type}}</td>

              <td v-if="contractType === 'apoone'">{{ result.company_name}}</td>
              <td v-else>{{result.org_full_name}}</td>

              <td>{{result.street}}</td>
              <td>{{result.zip_code}}</td>
              <td>{{result.city}}</td>
              <td>
                <b-btn size="sm" @click="selectAddress(result)">
                  <fa icon="arrow-right"/>
                </b-btn>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-overlay>
    <template #modal-footer="{ cancel }">

      <b-form-checkbox id="multiple-contracts" v-model="multipleContractsPerPractice" v-if="addressModeCheckbox" name="multiple-contracts">
        {{$t('sandoz.multiple_contracts_per_practice')}}
      </b-form-checkbox>

      <b-button @click="cancel()">
        {{$t('core.cancel')}}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
  import axios from 'axios'

  export default {
    props: {
        closeOnSelect: {
            type: Boolean,
            default: true
        },
        contractType: {
            type: String,
            default: 'kam'
        },
        addressModeCheckbox: {
          type: Boolean,
          default: false
        }
    },
    data: () => ({
      query: '',
      searchResult: [],
      owningComponent: null,
      multipleContractsPerPractice: false,
      config: {
        kam: {
          uri: `/api/sandoz/kam/contracts/search-addresses`,
          apo_one: false
        },
        icepeak: {
          uri: `/api/sandoz/ice-peak/contracts/search-addresses`,
          apo_one: false
        },
        apoone: {
          uri: `/api/sandoz/apo-one/contracts/search-addresses`,
          apo_one: true
        },
        educational: {
          uri: `/api/sandoz/educational/contracts/search-addresses`,
          apo_one: false
        },
        gadget: {
          uri: `/api/sandoz/gadget/contracts/search-addresses`,
          apo_one: false
        },
        pv: {
          uri: `/api/sandoz/pv/contracts/search-addresses`,
          apo_one: false
        }
      },
      displayOverlay: false
    }),
    watch: {
      multipleContractsPerPractice() {
        if (!this.query) {
          return
        }
        this.search()
      }
    },
    methods: {
      showAddressSearchModal(owningComponent) {
        this.owningComponent = owningComponent
        this.$refs.addressSearchModal.show()
      },
      search(ownContract = false) {
        this.displayOverlay = true
        
        let exactContractType = null;
        if (this.owningComponent && this.owningComponent.item && this.owningComponent.item.type) {
          exactContractType = this.owningComponent.item.type;
        }

        axios.post(this.config[this.contractType].uri, {
          q: this.query, 
          multipleContractsPerPractice: this.multipleContractsPerPractice, 
          ownContract: ownContract, 
          is_apo_one: this.config[this.contractType].apo_one,
          exact_contract_type: exactContractType
        }).then(response => {
          this.searchResult = response.data.data
          this.displayOverlay = false
        })
      },
      selectAddress(address) {
        this.$emit('address-selected', {owningComponent: this.owningComponent, address: address, multipleContractsPerPractice: this.multipleContractsPerPractice})
        this.searchResult = []
        this.query = ''

        if (this.closeOnSelect) {
          this.$refs.addressSearchModal.hide()
        }
      }
    }
  }
</script>
